import React, { PropsWithChildren } from 'react';

export const Legend: React.FC<PropsWithChildren> = ({ children }) => <legend className="legend">{children}</legend>;
